import React, { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import RootCauseAnalysisDataTable from "./RootCauseAnalysisDataTable";
import Loader from "../Molecules/Loader/Loader";

export interface IResearchQueryResultsDetail {
  rootCauseAnalysisData: any;
  selectedColumns: any;
  isLoading: boolean;
  isFilterHide: boolean;
  resourceKeys: any;
}

/**
 * ResearchQueryResultsDetail component for displaying research query results
 *
 * @param rootCauseAnalysisData - Data for root cause analysis
 * @param selectedColumns - Selected columns for filtering
 * @param isLoading - Loading state
 * @param isFilterHide - Filter visibility state
 * @param resourceKeys - Resource keys for filtering
 */
const ResearchQueryResultsDetail = ({
  rootCauseAnalysisData,
  selectedColumns,
  isLoading,
  isFilterHide,
  resourceKeys,
}: IResearchQueryResultsDetail) => {
  const [selectedQueryTab, setSelectedQueryTab] = useState<any>(0);

  const handleChangeQueryTab = (
    _event: React.SyntheticEvent,
    newValue: string
  ) => {
    setSelectedQueryTab(newValue);
  };
  
  return (
    <>
      <Tabs
        value={selectedQueryTab}
        onChange={handleChangeQueryTab}
        textColor="secondary"
        indicatorColor="secondary"
        className="mui-tabs no-t-lr-radius min-height-0 alternative-1"
        variant="scrollable"
        scrollButtons="auto"
      >
        {rootCauseAnalysisData.length > 0 &&
          rootCauseAnalysisData?.map((item: any, index: number) => (
            <Tab key={index} value={index} label={item.name} />
          ))}
      </Tabs>
      {rootCauseAnalysisData[selectedQueryTab] && (
        <Box className="position-relative">
          {isLoading && (
            <Loader
              isAbsolute={true}
              radius={{ top: 0, right: 0, bottom: 5, left: 5 }}
              isLoading={isLoading}
            />
          )}
          <RootCauseAnalysisDataTable
            rootCauseData={rootCauseAnalysisData[selectedQueryTab]}
            selectedColumns={selectedColumns}
            isLoading={isLoading}
            isFilterHide={isFilterHide}
            resourceKeys={resourceKeys}
          />
        </Box>
      )}
    </>
  );
};

export default ResearchQueryResultsDetail;
